import { FIND_COMPLETED_SAQ_LIST_SUCCESS, SAQ_CREATE_SUCCESS } from "../types/index";

const defaultState = {
  saqQuestions: [],
  completedSaqList: [],
  saq:{}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "FETCH_QUESTIONS_SAQ_A":
      return {
        ...state,
        saqQuestions: action.payload,
      };

    case FIND_COMPLETED_SAQ_LIST_SUCCESS:
      return { ...state, completedSaqList: action.payload };

      case SAQ_CREATE_SUCCESS:
        return {
          ...state,
          saq: action.payload,
        };


    default:
      return state;
  }
};
